import React from 'react';
import CollapsibleMultiTexts from '@gp/components/CollapsibleMultiTexts';
// import ChangeDetailProject from '../../ChangeDetailProject';
import { CommonColumnBuilders } from '@gp/utils/columns';
import ProjectColumnItem from '@gp/components/ProjectColumnItem';
import { formatTabName } from '../../../../../utils';
import { formatFieldValue } from './';
import { navigate2ProjectDetail } from './navigator';
import RestrictedContent from '@gp/components/RestrictedContent';
import type { TableColumn } from 'tea-component';
import type { IPipelineChangeDetailTableRecord } from '@gp/types/changeLog';

export const getColumns = (props?: { isShowAll?: boolean }): TableColumn<IPipelineChangeDetailTableRecord>[] => {
  const { isShowAll, handleExpandAll } = props || {};

  return [
    {
      key: 'project_id',
      align: 'left',
      header: 'Project',
      width: 224,
      render: (cvm: any) => <ProjectColumnItem data={cvm} isShowStage={true} />,
      // render: (cvm) => <ChangeDetailProject data={cvm} />,
    },
    CommonColumnBuilders.buildPureTextColumn({
      key: 'tab',
      align: 'left',
      header: 'Tab',
      width: 124,
      formatter: (cvm) => formatTabName(cvm?.tab),
      isExpandTab: true,
      handleExpandAll,
    }),
    {
      key: 'title',
      align: 'left',
      header: 'Title',
      width: 186,
      render: (cvm) => {
        const { project_id: projectId, project: projectName, tab, title_id: titleId, title } = cvm || {};
        const { project_auth: projectAuth } = cvm || ({} as any);
        const authKey = `tab_auth_${cvm?.tab}`;
        if (projectAuth === false || cvm?.[authKey] === false) return <RestrictedContent />;
        return (
          <textarea
            style={{
              resize: 'none',
              fontSize: 14,
              color: '#326FF0',
              background: 'none',
              border: 0,
              outline: 'none',
              cursor: 'pointer',
            }}
            readOnly
            rows={title === 'End of Pre-Production (Vertical Slice)' ? 3 : 2}
            value={title}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              navigate2ProjectDetail({
                tab,
                titleId,
                title,
                projectId,
                projectName,
              });
            }}
          ></textarea>
        );
      },
    },
    CommonColumnBuilders.buildPureTextColumn({
      key: 'field',
      align: 'left',
      header: 'Field',
      width: 170,
      permissionKey: ['tab_auth'],
    }),
    {
      key: 'old',
      align: 'left',
      header: 'Original Value',
      width: 212,
      render: (cvm: any) => {
        const { field, old: oldValue } = cvm || {};
        const { project_auth: projectAuth } = cvm || ({} as any);
        const authKeyTab = `tab_auth_${cvm?.tab}`;
        const authKeyFild = `field_auth_${cvm?.field}`;
        const isExpandShowAll = cvm?.isExpand === true;
        // const isExpandShowAll = cvm?.isExpand === true || isShowAll;
        if (projectAuth === false || cvm?.[authKeyTab] === false || cvm?.[authKeyFild] === false)
          return <RestrictedContent />;
        return (
          <CollapsibleMultiTexts
            isShowAll={isExpandShowAll}
            text={formatFieldValue(field, oldValue)}
            expandBtnText={'Expand All'}
          />
        );
      },
    },
    {
      key: 'new',
      align: 'left',
      header: 'New Value',
      width: 212,
      render: (cvm: any) => {
        const { field, new: newValue } = cvm || {};
        const { project_auth: projectAuth } = cvm || ({} as any);
        const authKeyTab = `tab_auth_${cvm?.tab}`;
        const authKeyFild = `field_auth_${cvm?.field}`;
        const isExpandShowAll = cvm?.isExpand === true;
        if (projectAuth === false || cvm?.[authKeyTab] === false || cvm?.[authKeyFild] === false)
          return <RestrictedContent />;
        return (
          <CollapsibleMultiTexts
            isShowAll={isExpandShowAll}
            text={formatFieldValue(field, newValue)}
            expandBtnText={'Expand All'}
          />
        );
      },
    },
    CommonColumnBuilders.buildLastUpdateColumn({
      permissionKey: ['tab_auth', 'field_auth'],
    }),
  ];
};
